import { hotHeadlines } from '@/mocks/articles';
import { Link } from 'react-router-dom';

export default function HotHeadlines() {
  const [main, ...rest] = hotHeadlines;

  return (
    <section className="px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight tracking-tight">
            热门<span className="text-accent-500">头条</span>
            <br />
            不容错过的<span className="text-accent-500">重磅爆料</span>
          </h2>
        </div>

        <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
          <Link
            to={`/article/${main.slug}`}
            className="lg:w-1/2 relative group cursor-pointer rounded-2xl overflow-hidden h-[360px] md:h-[480px]"
          >
            <img
              src={main.image}
              alt={main.title}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-7">
              <span className="inline-block px-3 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium mb-3">
                {main.category}
              </span>
              <h3 className="text-xl md:text-2xl font-heading font-bold text-white leading-snug mb-2">
                {main.title}
              </h3>
              <p className="text-sm text-white/70 line-clamp-2 mb-3">{main.excerpt}</p>
              <div className="flex items-center gap-4 text-xs text-white/60">
                <span>{main.date}</span>
                <span>{main.views} 阅读</span>
              </div>
            </div>
          </Link>

          <div className="lg:w-1/2 flex flex-col gap-4 md:gap-5">
            {rest.map((item, index) => (
              <Link
                key={item.slug}
                to={`/article/${item.slug}`}
                className="relative group cursor-pointer rounded-2xl overflow-hidden h-[172px] md:h-[230px]"
              >
                <img
                  src={item.image}
                  alt={item.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className={`absolute inset-0 ${
                  index === 0
                    ? 'bg-gradient-to-r from-accent-900/50 to-black/30'
                    : 'bg-gradient-to-r from-primary-900/40 to-black/30'
                }`}></div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <span className={`inline-block px-2.5 py-1 rounded-full text-xs font-medium mb-2.5 ${
                    index === 0 ? 'bg-accent-500/90 text-background-50' : 'bg-secondary-500/90 text-foreground-950'
                  }`}>
                    {item.category}
                  </span>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-white leading-snug mb-1.5">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-3 text-xs text-white/60">
                    <span>{item.date}</span>
                    <span>{item.views} 阅读</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}